import React from 'react';
import styled from 'styled-components';

const StyledCard = styled.div`
	position: relative;
	background: ${({ theme }) => theme.colors.white};
	box-shadow: 0 7px 13px ${({ theme }) => theme.colors.shadow};
	border-radius: 18px;
	padding: 20px;
	box-sizing: border-box;
`;

export const Card: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, ...props }) => {
	return <StyledCard {...props}>{children}</StyledCard>;
};
